module.exports = __webpack_public_path__ + "img/pic-04.8e1ec77d.png";